export default __webpack_public_path__ + "static/media/AddStudent.3d800c5d.svg";